import { Modal, Table, Form, Input, Button, Col, Row, message } from "antd"
import axios from "axios";
import { data } from "react-router-dom";
import { CREATE_DG, CREATE_DG_HANDLE, HEADERS_BASIC, LOAD_MAIN_DG_HANDLE } from "../../../API/apiUrlsNew";
import React, { useEffect, useState, useMemo } from "react";
import ModalAddDG_Handle from "./modalAddDG_Handle";
import dayjs from "dayjs";


const ModalDemandGuaranterHandle = ({ open, close, dataRecord, fetchData }) => {
    const [form] = Form.useForm();
    const USERNAME = localStorage.getItem("USERNAME");
    const [displayData, setDisplayData] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
    const [errorMap, setErrorMap] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [arrData, setArrData] = useState([]);
    const [datePicker, setDatePicker] = useState(dayjs());

    const [arrayTable, setArrayTable] = useState([]);

    const [modalAddDGHandle, setModalAddDGHandle] = useState(false);

    useEffect(() => {
        loadDataDemandGusranter();
    }, [])


    console.log('dataRecord', dataRecord);

    const handleClose = () => {
        close(false);
    }


    const changePage = (newPage, newPageSize) => {
        // saveCurrentPageToMaster();
        setPagination(prev => ({ ...prev, current: newPage, pageSize: newPageSize || prev.pageSize }));
    };

    // const getEffectiveData = () => {
    //     const currentFormValues = form.getFieldsValue().rows || {};
    //     return masterData.map(row => {
    //         const formRow = currentFormValues[row.key] || {};
    //         return { ...row, ...formRow };
    //     });
    // };



    const loadDataDemandGusranter = async () => {
        let datapost = {
            CONTNO: [dataRecord.CONTNO],
            company: '1',
            contnoType: dataRecord.SCHEMA,
            date: dayjs().toISOString()
        }


        await axios.post(LOAD_MAIN_DG_HANDLE,
            datapost,
            {
                headers: HEADERS_BASIC

            })
            .then((res) => {
                console.log("res", res.data);
                setData(res.data);
                setArrayTable(res.data);
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    const insertData = async () => {

        if (!arrayTable || (Array.isArray(arrayTable) && arrayTable.length === 0)) {
            message.error("ไม่มีข้อมูลที่บันทึก");
            return;
        }

        // setLoading(true);
        let sendData = {
            contractSchema: dataRecord.SCHEMA,
            roundDate: datePicker,
            demandGuarantor: arrayTable,
            user: USERNAME
        }
        console.log("sendData", sendData);


        await axios.post(CREATE_DG_HANDLE, sendData, { headers: HEADERS_BASIC })
            .then((res) => {
                if (res.status === 200) {
                    message.success("สร้างข้อมูลใหม่สำเร็จ");
                    fetchData()
                }
            })
            .catch((error) => {
                // 5. จัดการเมื่อ Error
                const status = error?.response?.status;
                const serverMsg =
                    error?.response?.data?.message ||
                    error?.response?.data?.error ||
                    error.message;

                message.error(
                    `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`
                );

                console.error("insertData error:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };


    // const loadDataDemandGusranter = async () => {

    //     // await axios.get(`http://localhost:8070/api-inv/load-dg/${dataRecord.CONTNO}`,
    //     await axios.get(`http://localhost:8070/api-inv/load-dg/2-0008106`,
    //         {
    //             headers: HEADERS_BASIC

    //         })
    //         .then((res) => {
    //             console.log("res", res.data);
    //             setData(res.data);
    //         })
    //         .catch((err) => {
    //             console.log("err", err);
    //         })
    // }

    // const handleInputComplete = (rowIndex, type, value) => {
    //     const pageSize = pagination.pageSize;
    //     const startIndex = (pagination.current - 1) * pageSize;
    //     const record = displayData[startIndex + rowIndex];
    //     if (!record) return;

    //     const rowKey = record.key;
    //     const fieldName = type === 'mail' ? 'parcelNo' : 'parcelNoResponse';

    //     // เช็คซ้ำ Global
    //     const effectiveData = getEffectiveData();
    //     const isDuplicate = effectiveData.find(d =>
    //         (d.parcelNo === value && (d.key !== rowKey || fieldName !== 'parcelNo')) ||
    //         (d.parcelNoResponse === value && (d.key !== rowKey || fieldName !== 'parcelNoResponse'))
    //     );

    //     if (isDuplicate) {
    //         Modal.error({ title: 'เลขซ้ำ', content: `เลข ${value} ถูกใช้ไปแล้ว` });
    //         setErrorMap(prev => ({ ...prev, [`${rowKey}-${fieldName}`]: true }));
    //         form.setFieldValue(["rows", rowKey, fieldName], null);
    //         return;
    //     }

    //     // ถ้าผ่าน -> เคลียร์ error
    //     setErrorMap(prev => {
    //         const newMap = { ...prev };
    //         delete newMap[`${rowKey}-${fieldName}`];
    //         return newMap;
    //     });

    //     setTimeout(updateProgress, 50);

    //     // ย้าย Focus
    //     if (type === 'mail') {
    //         document.getElementById(`input-parcelNoResponse-${rowIndex}`)?.focus();
    //     } else {
    //         const currentItemsOnPage = displayData.slice(startIndex, startIndex + pageSize).length;
    //         if (rowIndex === currentItemsOnPage - 1) {
    //             handleNextPageFocus();
    //         } else {
    //             document.getElementById(`input-parcelNo-${rowIndex + 1}`)?.focus();
    //         }
    //     }
    // };


    const columns = useMemo(() => [
        { title: "ลำดับ", dataIndex: "key", width: 70, align: 'center', fixed: 'left' },
        { title: "สัญญา", dataIndex: "CONTNO", width: 80, align: 'center' },
        // { title: "ชื่อ-นามสกุล", dataIndex: "customerFullName", width: 180, ellipsis: true },
        {
            title: 'ชื่อ-นามสกุล',
            dataIndex: 'customerFullName',
            width: 180,
            ellipsis: true,
            align: "center",
            render: (text, record) =>
                <>
                    {/* {`${record?.customerFullName}`} (คค.{record.customerTypeId}) */}
                    {`${record?.SNAM + record?.NAME1 + ' ' + record?.NAME2}`} (คค.{record.GARNO})
                </>

            ,
        },
        {
            title: 'ประเภทลูกค้า',
            dataIndex: 'GARNO',
            width: 100,
            align: "center",
            ellipsis: true,
            render: (text, record) =>
                <>
                    {/* {`${record?.customerFullName}`} (คค.{record.customerTypeId}) */}
                    {`คนค้ำประกันที่ ${record.GARNO}`}
                </>

            ,
        },
        {
            title: 'ค้างงวด(จริง)',
            dataIndex: 'HLDNO',
            width: 100,
            ellipsis: true,
            align: "center",
        },
        {
            title: 'ค้างชำระ(วัน)',
            dataIndex: 'DPD_DAYS',
            width: 100,
            ellipsis: true,
            align: "center",
        },


    ]);



    return (
        <>
            <Modal
                open={open}
                onCancel={handleClose}
                width={1200}
                footer={null}
                maskClosable={false}   // ✅ กันกดข้างนอกแล้วปิด

            >

                <Row justify="end" gutter={16} style={{ marginBottom: 16, marginTop: 30 }}>
                    <Col>
                        <Button
                            // type="primary"
                            onClick={() => insertData()}
                            style={{ color: "green" }}
                        >
                            บันทึก
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            onClick={() => setModalAddDGHandle(true)}
                            danger
                        >
                            นำเข้าเลขไปรษณีย์
                        </Button>
                    </Col>
                </Row>



                <Table
                    rowKey="key"
                    columns={columns}
                    dataSource={arrayTable}
                    size="small"
                    bordered
                    scroll={{ y: 500, x: 800 }}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: displayData.length,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50', '100', '200'],
                        onChange: (p, s) => changePage(p, s),
                        showTotal: (total, range) => `${range[0]}-${range[1]} จาก ${total}`
                    }}
                    rowSelection={{ selectedRowKeys, onChange: setSelectedRowKeys }}
                    onRow={(record) => {
                        return {
                            style: {
                                // เช็คเงื่อนไขตรงนี้: ถ้า flagClose เป็น true ให้พื้นหลังแดง (ใช้สีแดงอ่อนๆ จะอ่านง่ายกว่าแดงสด)
                                backgroundColor: record.flagClose ? '#ffccc7' : 'inherit',
                            }
                        };
                    }}
                />

            </Modal>
            {
                modalAddDGHandle && (
                    <ModalAddDG_Handle
                        open={modalAddDGHandle}
                        close={setModalAddDGHandle}
                        dataRecord={dataRecord}
                    />
                )
            }
        </>
    )
}

export default ModalDemandGuaranterHandle